import contactUs from "../../assets/gif/contact_us.gif"

export const data = {
  development: {
    heading: "Contact Us",
    imageSrc: contactUs,
    description: "At TACTECH, client contact is the cornerstone of our service. We eagerly anticipate hearing from you, be it for inquiries, feedback, or simply to engage in conversation. Your outreach not only elevates our day but strengthens the client-community relationship. Every message is a testament to the trust you place in us, inspiring us to consistently deliver excellence. So, please, never hesitate to get in touch - your communication is invaluable to us. So join us now in shaping the future!",
  },
};
